import React from 'react'
import { useBreakpoint } from '@vtex/admin-ui'

import { ProductDetailsSectionContent } from './ProductDetailsSectionContent'
import type { ProductDetailsDrawer_Product$key } from './__generated__/ProductDetailsDrawer_Product.graphql'

type ProductDetailsSectionMobileProps = {
  productDescription: ProductDetailsDrawer_Product$key
}

export const ProductDetailsSectionMobile = ({
  productDescription,
}: ProductDetailsSectionMobileProps) => {
  const { breakpoint } = useBreakpoint()
  const isMobileOrTablet = ['mobile', 'tablet'].includes(breakpoint)

  if (!isMobileOrTablet) {
    return null
  }

  return (
    <ProductDetailsSectionContent productDescription={productDescription} />
  )
}
